import { Log } from '../../shared/log';
const log = new Log('WidgetService');

import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { IWidget } from '../../interfaces/interfaces';
import { AppConfig } from '../../app.config';

import 'rxjs/add/operator/toPromise';
import { BroadcastService } from '../broadcast/broadcast.service';

@Injectable()
export class WidgetService {
    private serverUrl = this.appConfig.getValue('endPoint');
    private publicWidgetsUrl = this.serverUrl + 'widgets';

    private widgets;

    constructor(private authHttp: AuthHttp,
                private appConfig: AppConfig,
                private broadcastService: BroadcastService) {
    }

    getPublicWidgets(): Promise<IWidget[]> {
        if (this.widgets == null) {
          return this.authHttp
            .get(this.publicWidgetsUrl)
            .toPromise()
            .then((response) => {
              this.widgets = response.json();
              return this.widgets;
            })
            .catch((error) => {
              this.broadcastService.nowidgets.next('NoWidgets ' + error);
            });
        } else {
            return new Promise((resolve, reject) => {
                resolve(this.widgets);
            });
        }

    }

    private handleError(error: any) {
        log.error(error);
        return Promise.reject(error);
    }

    private extractData(res: Response) {
        const body = res.json();
        return body.data || body || {};
    }
}



// WEBPACK FOOTER //
// ./app/services/widget/widget.service.ts